import React from "react";

import { SlideFilter } from "2g-slide-filter";
import { Field, Inputs, Row } from "2g-form";
import { required } from "2g-validators-common";
import { roundToEndOfDay } from "b2b/formatters";

import { DateTime } from "b2b/renderers";
import useMessages from "./i18n/useMessages";

const requiredValidator = required();

function ProvozniInformaceSearch(props) {
  const messages = useMessages();
  return (
    <SlideFilter {...props} title={messages.label()}>
      <Row styled>
        <Field
          component={Inputs.DateTimePicker}
          mask="DD/MM/YYYY"
          date
          milliseconds
          path="datumOd"
          label={messages.dateFromLabel()}
          placeholder={messages.dateFromPlaceholder()}
          required
          validators={requiredValidator}
          descriptionRenderer={DateTime}
        />
      </Row>
      <Row styled>
        <Field
          component={Inputs.DateTimePicker}
          mask="DD/MM/YYYY"
          date
          milliseconds
          formatter={roundToEndOfDay}
          path="datumDo"
          label={messages.dateToLabel()}
          placeholder={messages.dateToPlaceholder()}
          required
          validators={requiredValidator}
          descriptionRenderer={DateTime}
        />
      </Row>
    </SlideFilter>
  );
}

export default React.memo(ProvozniInformaceSearch);
